"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchButton = void 0;
var React = __importStar(require("react"));
var useHeaderProps_1 = require("../../hooks/useHeaderProps");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var Icon_1 = require("../../../Icon");
var HeaderLink_1 = require("../_shared/HeaderLink");
var SearchButton = function (_a) {
    var withManage = _a.withManage, withNotifications = _a.withNotifications;
    var colorSet = (0, useHeaderProps_1.useHeaderProps)().colorSet;
    return (React.createElement(HeaderLink_1.HeaderLink, { href: "/Search", isRounded: true },
        React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faSearch, color: colorSet === null || colorSet === void 0 ? void 0 : colorSet.text, boxSize: 6 })));
};
exports.SearchButton = SearchButton;
